module.exports = __webpack_public_path__ + "img/santa-icon.4e9d56fa.svg";